import { graphql, useMutation } from "react-relay";
import { useToast } from "src/hooks/use-toast";

import { useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation } from "./__generated__/useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation.graphql";

// Mutation for submitting memory attribution feedback
const submitMemoryAttributionFeedbackMutation = graphql`
  mutation useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation($input: SubmitMemoryAttributionFeedbackInput!) {
    submitMemoryAttributionFeedback(input: $input) {
      success
    }
  }
`;

export type MemoryAttributionFeedbackType = "RELEVANT" | "NOT_RELEVANT";

export const useSubmitMemoryAttributionFeedbackMutation = () => {
  const { toast } = useToast();
  const [commitSubmitFeedback, isInFlight] = useMutation<useSubmitMemoryAttributionFeedbackMutationSubmitMemoryAttributionFeedbackMutation>(submitMemoryAttributionFeedbackMutation);

  const handleSubmitFeedback = (
    memoryId: string,
    conversationId: string,
    messageId: string,
    feedbackType: MemoryAttributionFeedbackType,
    onSuccess?: () => void,
    options?: {
      isV2?: boolean;  // If true, use llmConversationId/llmMessageId fields
    }
  ) => {
    const isV2 = options?.isV2 || false;

    commitSubmitFeedback({
      variables: {
        input: isV2 ? {
          memoryId,
          llmConversationId: conversationId,
          llmMessageId: messageId,
          feedbackType,
        } : {
          memoryId,
          conversationId,
          messageId,
          feedbackType,
        }
      },
      onCompleted: () => {
        onSuccess?.();
        toast({
          title: "Thank you for your feedback!",
          variant: "success",
        });
      },
      onError: (error) => {
        toast({
          title: "Error submitting feedback",
          description: error.message,
          variant: "error",
        });
      }
    });
  };

  return {
    handleSubmitFeedback,
    isSubmittingFeedback: isInFlight
  };
};
